import { useContext, useContextSelector } from 'use-context-selector';
import OrderStepsContext from '../contexts/OrderStepsContext';
import type { OrderStepsContextValue } from '../contexts/OrderStepsContext';

// Overload for when no selector is provided. Returns the entire context value.
function useOrderSteps(): OrderStepsContextValue;
// Overload for when a selector is provided. Returns only the selected slice of state.
function useOrderSteps<T>(selector: (state: OrderStepsContextValue) => T): T;
// Implementation of the overloaded function.
function useOrderSteps<T>(selector?: (state: OrderStepsContextValue) => T): T | OrderStepsContextValue {
  // If a selector function is passed, use useContextSelector for performance.
  if (selector) {
    return useContextSelector(OrderStepsContext, selector);
  }
  // Otherwise, return the entire context value for backward compatibility.
  return useContext(OrderStepsContext);
}

export default useOrderSteps;
